// import Main from './Main'
import ListaArrematantes from './components/ListaArrematantes'
const Monitor = () => import('./components/Monitor')
const Aprovacao = () => import('./components/MonitorAprovacao')
const Habilitacao = () => import('./components/MonitorHabilitacao')

export default [
  // { path: '/arrematantes', component: Main, name: 'arrematantes.main' },
  {path: '/arrematantes/lista', component: ListaArrematantes, name: 'arrematantes.lista'},
  {path: '/arrematantes/exportar', component: () => import('./components/ExportarBase'), name: 'arrematantes.exportar'},
  {path: '/arrematantes/monitor', component: Monitor, name: 'arrematantes.monitor'},
  {path: '/arrematantes/aprovacao', component: Aprovacao, name: 'arrematantes.aprovacao'},
  {path: '/arrematantes/habilitacao', component: Habilitacao, name: 'arrematantes.habilitacao'},
]
